import getLpcClient, { lpcResponse } from "../lpcClient";
import { LpcConnectionData } from "../lpcConnectionData";

export enum FlightType {
  ONEWAY = "oneway",
  RETURN = "return",
}

interface PeriodCalendarV2Request {
  origin: string;
  destination: string;
  flightType: FlightType.ONEWAY | FlightType.RETURN;
  periodStart: string;
  periodEnd: string;
  maxTransfers: number;
}

interface PeriodCalendarV2Response {
  [date: string]: {
    price: number;
    departure: string;
    arrival: string;
    detail: {
      Price: number;
      PriceCurrency: string;
    };
  };
}

export default async (
  {
    origin,
    destination,
    flightType = FlightType.ONEWAY,
    periodStart,
    periodEnd,
    maxTransfers = 1,
  },
  connectionData?: LpcConnectionData
) => {
  const body: PeriodCalendarV2Request = {
    origin,
    destination,
    flightType,
    periodStart,
    periodEnd,
    maxTransfers,
  };

  const client = await getLpcClient(connectionData);
  const response = await lpcResponse(client.post("/v2/period-calendar", body));

  if (!response.success) {
    return {};
  }

  const data: PeriodCalendarV2Response = response.data?.context;
  return data;
};
